import styled from "styled-components";
import {CharcoalBlack, DarkSlate, ErrorRed, Silver, Teal, White} from "../../../theme/variable";
import arrowGray from "../../../images/Arrow-Gray.png";
import arrowTeal from "../../../images/Arrow-Teal.png";
import {validateField} from "../../../utils/validation";
import {media} from "../../../theme/responsive";
import arrowRed from "../../../images/Arrow-Red.png";

const height = "36px";
const thumbHeight = 24;
const thumbWidth = 24;
const trackHeight = "4px";

const lowerBackground = `linear-gradient(to bottom, ${Teal}, ${Teal}) 100% 50% / 100% ${trackHeight} no-repeat transparent`;
const defaultBackground = `linear-gradient(to bottom, ${Silver}, ${Silver}) 100% 50% / 100% ${trackHeight} no-repeat transparent`;

// Webkit cannot style progress so we fake it with a long shadow on the thumb element
const makeLongShadow = (color, size) => {
    let i = 0;
    let shadow = `${i}px 0 0 ${size} ${color}`;

    for (; i < 1006; i++) {
        shadow = `${shadow}, ${i}px 0 0 ${size} ${color}`;
    }

    return shadow;
};
export const RangeInputFieldWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    position: relative;
    ${media.laptop`margin:6px 0;`}
`;
export const RangeInputField = styled.div`
    display: inline-block;
    margin-bottom: 15px;
    position: relative;
    width: ${(props) => {
        if (validateField(props, "object", "rangeInputStyle.mobile.width"))
            return props.rangeInputStyle.mobile.width;
        return "100%";
    }};
    ${media.laptop`  width: ${(props) => {
        if (validateField(props, "object", "rangeInputStyle.laptop.width"))
            return props.rangeInputStyle.laptop.width;
        return "100%";
    }}; `}
`;

export const Input = styled.input`
    overflow: hidden;
    display: block;
    appearance: none;
    max-width: 1000px;
    width: 100%;
    margin: 0;
    height: ${height};
    cursor: pointer;

    &:focus {
        outline: none;
    }

    &::-webkit-slider-runnable-track {
        width: 100%;
        height: ${height};
        background: ${(props) =>
            props.defaultState ? `${defaultBackground}` : `${lowerBackground}`};
        position: relative;
    }

    &::-webkit-slider-thumb {
        // position: absolute;
        appearance: none;
        height: ${thumbHeight}px;
        width: ${thumbWidth}px;
        background: ${(props) =>
            props.isError ? `url(${arrowRed}) no-repeat` : ` url(${arrowGray}) no-repeat`};
        background-position: -4px -4px;
        border-radius: 100%;
        border: 0;
        // top: 50%;
        margin-top: 18px;
        // margin-left: ${(props) => (props.defaultState ? "-45%" : "0")};
        transform: translateY(-50%);
        box-shadow: ${makeLongShadow(Silver, "-10px")};
        transition: background-color 150ms;
        ${media.laptop`
            // margin-left: ${(props) => (props.defaultState ? "-116px" : "")};
            margin-top:18px;
            position:unset;
            top:unset;
            `}
        &:before {
            content: "";
        }
    }

    &&::-moz-range-thumb {
        height: ${thumbHeight}px;
        width: ${thumbWidth}px;
        border-radius: 50%;
        cursor: pointer;
        background-color: ${White};
        background: ${(props) =>
            props.isError ? `url(${arrowRed}) no-repeat` : ` url(${arrowGray}) no-repeat`};
        background-position: -4px -4px;
        border: none;
    }
    &::-ms-thumb {
        height: ${thumbHeight}px;
        width: ${thumbWidth}px;
        border-radius: 50%;
        background: ${White} url(${arrowGray}) no-repeat;
        background-position: -4px -4px;
        cursor: pointer;
        border: none;
    }
    &::-moz-range-track {
        width: 100%;
        height: 4px;
        cursor: pointer;
        background: #d2d2d2;
    }
    &::-ms-track {
        width: 100%;
        height: 4px;
        cursor: pointer;
        background: transparent;
        border-color: transparent;
        border-width: 16px 0;
        color: transparent;
    }
    &::-ms-fill-lower {
        background: #2a6495;
        border: 0.2px solid #010101;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    }
    &:focus::-ms-fill-lower {
        background: #3071a9;
    }
    &::-ms-fill-upper {
        background: #3071a9;
        border: 0.2px solid #010101;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    }
    &:focus::-ms-fill-upper {
        background: #367ebd;
    }
    &::-moz-range-progress {
        background-color: ${(props) => (props.defaultState ? "#d2d2d2" : "#1048c3")};
    }
    &::-moz-range-track {
        background-color: #d2d2d2;
    }
    &:hover,
    &:focus {
        &::-webkit-slider-thumb {
            background: url(${arrowTeal}) no-repeat;
            background-position: -4px -2px;
        }
        &::-moz-range-thumb {
            background: ${White} url(${arrowTeal}) no-repeat;
            background-position: -4px -2px;
        }
        &::-ms-thumb {
            background: ${White} url(${arrowTeal}) no-repeat;
            background-position: -4px -2px;
        }
    }
`;

export const RangeInputLabel = styled.label`
    display: block;
    font-size: 0.9375rem;
    line-height: 1.6;
    font-weight: 600;
`;

export const MinMaxValue = styled.div`
    width: 100%;
    position: absolute;
    > span {
        font-size: 0.9375rem;
        line-height: 1.6;
        color: ${DarkSlate};
        left: 0;
        top: -7px;
        position: absolute;
        &:last-child {
            right: 0;
            left: auto;
        }
    }
`;

export const NumberInput = styled.input`
    width: 64px;
    height: 32px;
    border-radius: 2px;
    border: ${(props) => (props.isError ? `solid 1px ${ErrorRed}` : `solid 1px ${CharcoalBlack}`)};
    text-align: center;
    outline: none;
    -moz-appearance: textfield;
    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    ::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;
